/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './admin-root.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '../shared/notification.service';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '@angular/core/src/linker/element_ref';
import * as import10 from '@angular/router/src/router';
import * as import11 from '../shared/auth.service';
import * as import12 from '@angular/core/src/metadata/view';
import * as import13 from '@angular/core/src/linker/component_factory';
import * as import14 from '../../../node_modules/admin-lte/dist/css/AdminLTE.min.css.shim';
import * as import15 from '../shared/language-routing.component.ngfactory';
import * as import16 from './admin-header.component.ngfactory';
import * as import17 from './admin-menu.component.ngfactory';
import * as import18 from '../../../node_modules/@angular/router/src/directives/router_outlet.ngfactory';
import * as import19 from './admin-footer.component.ngfactory';
import * as import20 from '../shared/config.service';
import * as import21 from '@angular/common/src/location/location';
import * as import22 from '../shared/utils.service';
import * as import23 from 'angular2-cookie/services/cookies.service';
import * as import24 from '@angular/router/src/router_outlet_map';
import * as import25 from '@angular/core/src/linker/component_factory_resolver';
import * as import26 from './admin-header.component';
import * as import27 from './admin-menu.component';
import * as import28 from '@angular/router/src/directives/router_outlet';
import * as import29 from './admin-footer.component';
import * as import30 from '../shared/language-routing.component';
export class Wrapper_AdminRootComponent {
  context:import0.AdminRootComponent;
  changed:boolean;
  constructor(p0:any,p1:any) {
    this.changed = false;
    this.context = new import0.AdminRootComponent(p0,p1);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_AdminRootComponent_Host:import2.RenderComponentType = (null as any);
class _View_AdminRootComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _AdminRootComponent_0_4:Wrapper_AdminRootComponent;
  __NotificationService_0_5:import4.NotificationService;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_AdminRootComponent_Host0,renderType_AdminRootComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  get _NotificationService_0_5():import4.NotificationService {
    if ((this.__NotificationService_0_5 == (null as any))) { (this.__NotificationService_0_5 = new import4.NotificationService(new import9.ElementRef(this._el_0),this.renderer)); }
    return this.__NotificationService_0_5;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer,'ng-component',import5.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_AdminRootComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._AdminRootComponent_0_4 = new Wrapper_AdminRootComponent(this.parentInjector.get(import10.Router),this.parentInjector.get(import11.AuthService));
    this._appEl_0.initComponent(this._AdminRootComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._AdminRootComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.AdminRootComponent) && (0 === requestNodeIndex))) { return this._AdminRootComponent_0_4.context; }
    if (((token === import4.NotificationService) && (0 === requestNodeIndex))) { return this._NotificationService_0_5; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AdminRootComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._AdminRootComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_AdminRootComponent_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_AdminRootComponent_Host === (null as any))) { (renderType_AdminRootComponent_Host = viewUtils.createRenderComponentType('',0,import12.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_AdminRootComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const AdminRootComponentNgFactory:import13.ComponentFactory<import0.AdminRootComponent> = new import13.ComponentFactory<import0.AdminRootComponent>('ng-component',viewFactory_AdminRootComponent_Host0,import0.AdminRootComponent);
const styles_AdminRootComponent:any[] = [import14.styles];
var renderType_AdminRootComponent:import2.RenderComponentType = (null as any);
class _View_AdminRootComponent0 extends import1.AppView<import0.AdminRootComponent> {
  _text_0:any;
  _el_1:any;
  _LanguageRoutingComponent_1_3:import15.Wrapper_LanguageRoutingComponent;
  _text_2:any;
  _text_3:any;
  _el_4:any;
  /*private*/ _appEl_4:import3.AppElement;
  _AdminHeaderComponent_4_4:import16.Wrapper_AdminHeaderComponent;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  /*private*/ _appEl_7:import3.AppElement;
  _AdminMenuComponent_7_4:import17.Wrapper_AdminMenuComponent;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _RouterOutlet_15_5:import18.Wrapper_RouterOutlet;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  /*private*/ _appEl_18:import3.AppElement;
  _AdminFooterComponent_18_4:import19.Wrapper_AdminFooterComponent;
  _text_19:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_AdminRootComponent0,renderType_AdminRootComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._text_0 = this.renderer.createText(parentRenderNode,'    ',(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,parentRenderNode,'div',new import5.InlineArray4(4,'class','wrapper','lg-routing',''),(null as any));
    this._LanguageRoutingComponent_1_3 = new import15.Wrapper_LanguageRoutingComponent(this.parentInjector.get(import20.ConfigService),this.parentInjector.get(import21.Location),this.parentInjector.get(import10.Router),this.parentInjector.get(import22.UtilsService),this.parentInjector.get(import23.CookieService));
    this._text_2 = this.renderer.createText(this._el_1,'\n\n        ',(null as any));
    this._text_3 = this.renderer.createText(this._el_1,'\n        ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_1,'admin-header',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_4 = new import3.AppElement(4,1,this,this._el_4);
    var compView_4:any = import16.viewFactory_AdminHeaderComponent0(this.viewUtils,this.injector(4),this._appEl_4);
    this._AdminHeaderComponent_4_4 = new import16.Wrapper_AdminHeaderComponent(this.parentInjector.get(import20.ConfigService));
    this._appEl_4.initComponent(this._AdminHeaderComponent_4_4.context,([] as any[]),compView_4);
    this._text_5 = this.renderer.createText((null as any),'\n        ',(null as any));
    compView_4.create(this._AdminHeaderComponent_4_4.context,([] as any[]),(null as any));
    this._text_6 = this.renderer.createText(this._el_1,'\n        \n        ',(null as any));
    this._el_7 = import5.createRenderElement(this.renderer,this._el_1,'admin-menu',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_7 = new import3.AppElement(7,1,this,this._el_7);
    var compView_7:any = import17.viewFactory_AdminMenuComponent0(this.viewUtils,this.injector(7),this._appEl_7);
    this._AdminMenuComponent_7_4 = new import17.Wrapper_AdminMenuComponent(this.parentInjector.get(import22.UtilsService));
    this._appEl_7.initComponent(this._AdminMenuComponent_7_4.context,([] as any[]),compView_7);
    this._text_8 = this.renderer.createText((null as any),'\n        ',(null as any));
    compView_7.create(this._AdminMenuComponent_7_4.context,([] as any[]),(null as any));
    this._text_9 = this.renderer.createText(this._el_1,'\n\n        ',(null as any));
    this._el_10 = import5.createRenderElement(this.renderer,this._el_1,'div',new import5.InlineArray2(2,'class','content-wrapper white-bg'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._text_12 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_10,'div',new import5.InlineArray2(2,'id','snackbar'),(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n\n            ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_10,'router-outlet',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_15 = new import3.AppElement(15,10,this,this._el_15);
    this._RouterOutlet_15_5 = new import18.Wrapper_RouterOutlet(this.parentInjector.get(import24.RouterOutletMap),this._appEl_15.vcRef,this.parentInjector.get(import25.ComponentFactoryResolver),(null as any));
    this._text_16 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_1,'\n\n        ',(null as any));
    this._el_18 = import5.createRenderElement(this.renderer,this._el_1,'admin-footer',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._appEl_18 = new import3.AppElement(18,1,this,this._el_18);
    var compView_18:any = import19.viewFactory_AdminFooterComponent0(this.viewUtils,this.injector(18),this._appEl_18);
    this._AdminFooterComponent_18_4 = new import19.Wrapper_AdminFooterComponent();
    this._appEl_18.initComponent(this._AdminFooterComponent_18_4.context,([] as any[]),compView_18);
    compView_18.create(this._AdminFooterComponent_18_4.context,([] as any[]),(null as any));
    this._text_19 = this.renderer.createText(this._el_1,'\n      \n    ',(null as any));
    this.init(([] as any[]),[
      this._text_0,
      this._el_1,
      this._text_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import26.AdminHeaderComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._AdminHeaderComponent_4_4.context; }
    if (((token === import27.AdminMenuComponent) && ((7 <= requestNodeIndex) && (requestNodeIndex <= 8)))) { return this._AdminMenuComponent_7_4.context; }
    if (((token === import28.RouterOutlet) && (15 === requestNodeIndex))) { return this._RouterOutlet_15_5.context; }
    if (((token === import29.AdminFooterComponent) && (18 === requestNodeIndex))) { return this._AdminFooterComponent_18_4.context; }
    if (((token === import30.LanguageRoutingComponent) && ((1 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._LanguageRoutingComponent_1_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._LanguageRoutingComponent_1_3.detectChangesInInputProps(this,this._el_1,throwOnChange);
    const currVal_4_0_0:any = this._LanguageRoutingComponent_1_3.context;
    this._AdminHeaderComponent_4_4.check_lgRouting(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = this.context.loggedInUser;
    this._AdminHeaderComponent_4_4.check_loggedInUser(currVal_4_0_1,throwOnChange,false);
    this._AdminHeaderComponent_4_4.detectChangesInInputProps(this,this._el_4,throwOnChange);
    const currVal_7_0_0:any = this._LanguageRoutingComponent_1_3.context.currentLanguage;
    this._AdminMenuComponent_7_4.check_currentLanguage(currVal_7_0_0,throwOnChange,false);
    this._AdminMenuComponent_7_4.detectChangesInInputProps(this,this._el_7,throwOnChange);
    this._RouterOutlet_15_5.detectChangesInInputProps(this,this._el_15,throwOnChange);
    this._AdminFooterComponent_18_4.detectChangesInInputProps(this,this._el_18,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LanguageRoutingComponent_1_3.detectChangesInHostProps(this,this._el_1,throwOnChange);
    this._AdminHeaderComponent_4_4.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this._AdminMenuComponent_7_4.detectChangesInHostProps(this,this._el_7,throwOnChange);
    this._RouterOutlet_15_5.detectChangesInHostProps(this,this._el_15,throwOnChange);
    this._AdminFooterComponent_18_4.detectChangesInHostProps(this,this._el_18,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._RouterOutlet_15_5.context.ngOnDestroy();
  }
}
export function viewFactory_AdminRootComponent0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<import0.AdminRootComponent> {
  if ((renderType_AdminRootComponent === (null as any))) { (renderType_AdminRootComponent = viewUtils.createRenderComponentType('',0,import12.ViewEncapsulation.Emulated,styles_AdminRootComponent,{})); }
  return new _View_AdminRootComponent0(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-root.component.ngfactory.ts